import { render, staticRenderFns } from "./2_002_sf_ysfy.vue?vue&type=template&id=3a62761d"
import script from "./2_002_sf_ysfy.vue?vue&type=script&lang=js"
export * from "./2_002_sf_ysfy.vue?vue&type=script&lang=js"
import style0 from "./2_002_sf_ysfy.vue?vue&type=style&index=0&id=3a62761d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports